import { toast } from "react-toastify";
import {
  backend_url,
  uninterceptedAxiosInstance,
  qs,
} from "../common/commonVariables";

export const uploadFile = async (files) => {
  const formData = new FormData();
  files.forEach((file) => formData.append("files", file, file.name));

  try {
    const response = await uninterceptedAxiosInstance.post(
      backend_url + "upload",
      formData
    );
    let the_response = response;

    return the_response;
  } catch (err) {
    return toast.error(err.response?.data?.error?.message);
  }
};

export const removeFile = async (ID) => {
  try {
    const response = uninterceptedAxiosInstance.delete(
      backend_url + "upload/files/" + ID
    );

    let the_response = response;
    return the_response;
  } catch (err) {}
};

export const urlToFile = async (rel_url, name) => {
  const url = backend_url + rel_url.substring(1);
  const response = await fetch(rel_url);

  const blob = await response.blob();
  const file = new File([blob], name, { type: blob.type });
  return file;
};

export const imageUrlToFile = async (rel_url, name) => {
  const url = "/" + rel_url.substring(1);
  const response = await fetch(rel_url);
  const blob = await response.blob();
  const file = new File([blob], name, { type: blob.type });
  return file;
};

export const getAllLogs = async (type = "work_request", ID = "") => {
  let assetFilters = {
    type: {
      $eq: type,
    },
  };

  if (type == "work_request") {
    assetFilters.workRequest = {
      id: {
        $eq: ID,
      },
    };
  } else if (type == "purchase_order") {
    assetFilters.purchaseOrder = {
      id: {
        $eq: ID,
      },
    };
  } else if (type == "location") {
    assetFilters.location = {
      id: {
        $eq: ID,
      },
    };
  } else if (type == "user") {
    assetFilters.logOfUser = {
      id: {
        $eq: ID,
      },
    };
  } else if (type == "asset") {
    assetFilters.asset = {
      id: {
        $eq: ID,
      },
    };
  } else if (type == "team") {
    assetFilters.team = {
      id: {
        $eq: ID,
      },
    };
  } else if (type == "procedure") {
    assetFilters.procedure = {
      id: {
        $eq: ID,
      },
    };
  } else if (type == "customer") {
    assetFilters.customer = {
      id: {
        $eq: ID,
      },
    };
  } else if (type == "vendor") {
    assetFilters.vendor = {
      id: {
        $eq: ID,
      },
    };
  } else if (type == "work_order") {
    assetFilters.workOrder = {
      id: {
        $eq: ID,
      },
    };
  } else if (type == "set") {
    assetFilters.set = {
      id: {
        $eq: ID,
      },
    };
  } else {
    assetFilters.part = {
      id: {
        $eq: ID,
      },
    };
  }

  const queryParams = {
    sort: ["id:desc"],
    filters: assetFilters,
    populate: [
      "",
      "user",
      "logOfUser",
      "customer",
      "user.userProfile",
      "user.profileImage",
      "part",
      "workRequest",
      "workOrder",
      "procedure",
      "team",
      "vendor",
      "set",
      "location",
      "purchaseOrder",
    ],
  };

  const query = qs.stringify(queryParams, {
    encodeValuesOnly: true,
  });

  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `logs?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data.data;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};
